module.exports = __webpack_public_path__ + "assets/speeding_fixed.3e14e4db.svg";